import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CriteriaService from "@services/CriteriaService";

export const getCriteria = createAsyncThunk(
  "criteria/list",
  async (params, {rejectWithValue}) => {
    try {
      const response = await CriteriaService.getCriteria(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  data: [],
  sort: {value: "created_at", direction: "desc"},
  search: "",
  page: 1,
  size: 5,
  totalData: null,
  totalPages: null,
  selectedData: null,
  errors: null,
  error: "",
  status: "",
};

const criteriaTableSlice = createSlice({
  name: "criteria-table",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setSelectedData(state, action) {
      state.selectedData = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.page = 1;
    },
    setPage(state, action) {
      state.page = Math.max(1, action.payload);
    },
    setSize(state, action) {
      state.size = action.payload;
    },
    setSort(state, action) {
      state.sort = action.payload;
    },
    setTotalPages(state, action) {
      state.totalPages = action.payload;
    },
    setTotalData(state, action) {
      state.totalData = action.payload;
    },
    decrementTotalData(state) {
      if (state.totalData != null) {
        state.totalData -= 1;
      }
    },
    clearTable() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCriteria.pending, (state) => {
        pendingState(state);
      })
      .addCase(getCriteria.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.totalData = action.payload.total;
        state.totalPages = action.payload.total
          ? Math.ceil(action.payload.total / state.size)
          : state.totalPages;
        fulfilledState(state);
      })
      .addCase(getCriteria.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setPage,
  setSort,
  clearTable,
  setTotalPages,
  setErrors,
  setError,
  setSize,
  setStatus,
  setSelectedData,
  setData,
  setSearch,
  setTotalData,
  decrementTotalData,
} = criteriaTableSlice.actions;

export default criteriaTableSlice.reducer;
